// Cloudflare Access OTP integration.
// The Worker validates the CF_Authorization JWT cookie. The PWA cannot read
// HttpOnly cookies, so we treat any 401/403 from the API as "not signed in"
// and bounce the user to the Cloudflare Access login flow.

const ACCESS_LOGIN_PATH = '/.auth/login';

export function redirectToLogin(returnTo: string = window.location.pathname): void {
  const url = `${ACCESS_LOGIN_PATH}?redirect_url=${encodeURIComponent(returnTo)}`;
  window.location.assign(url);
}

// Probe endpoint the Worker exposes to confirm the JWT is valid for this
// session. Returns true if the cookie is good, false if not.
export async function probeSession(): Promise<boolean> {
  try {
    const res = await fetch(
      `${(import.meta.env.VITE_API_BASE as string | undefined) ?? 'https://api.servicesteady.com'}/pwa/session`,
      { credentials: 'include' },
    );
    return res.ok;
  } catch {
    // Network error in dev — let the app render so we can iterate.
    return import.meta.env.DEV;
  }
}
